import HeadBanner from "../components/HeadBanner";
import bannerImg from "../assets/images/products-banner.png"
import OurProducts from "../components/OurProducts";
import HorizontalBar from "../components/HorizontalBar";
import Applications from "../components/Application";
import fuelImg from '../assets/images/fuel.png';
import cowImg from '../assets/images/cow.png';
import cokeImg from '../assets/images/coke.png';

const ProdData = [
    {
        title: "Fuel Bio Fuel / Absolute Alcohol",
        image: fuelImg,
        description: "Fuel Bio Fuel, also known as Absolute Alcohol, is a high-purity alcohol with applications in various industries. Primarily used as a renewable fuel source, it serves as an eco-friendly alternative to fossil fuels, reducing greenhouse gas emissions. It is also widely utilized in the pharmaceutical, chemical, and personal care industries.",
        applications: [
            "Energy Sector: Blended with gasoline to create Bio Fuel-blended fuels, improving combustion and reducing pollution.",
            "Pharmaceuticals: Used as a solvent and in the manufacture of sanitizers and other medical products.",
            "Chemical Industry: Acts as a raw material for producing esters, ethers, and other chemicals."
        ],
        benefits: [
            "Sustainable and renewable energy source.",
            "Reduces carbon emissions.",
            "Versatile applications across industries."
        ]
    },
    {
        title: "DDGS (Dry Distilled Grain Soluble)",
        image: cowImg,
        description: "DDGS is a high-protein by-product derived from the distillation process in Bio Fuel production. This nutrient-rich feed ingredient is widely used in the livestock and poultry industries as a cost-effective and sustainable alternative to traditional feed sources.",
        applications: [
            "Animal Feed: Provides essential proteins, amino acids, and minerals for cattle, poultry, and swine.",
            "Aquaculture: Used in fish feed formulations to enhance growth and nutrition."
        ],
        benefits: [
            "Improves livestock productivity and health.",
            "Reduces reliance on traditional feed crops, promoting sustainability.",
            "Economical and eco-friendly solution for the feed industry."
        ]
    },
    {
        title: "Liquid/Dry CO₂ (Carbon Dioxide)",
        image: cokeImg,
        description: "Carbon Dioxide (CO₂), available in both liquid and dry forms, is a versatile industrial gas used across multiple sectors. It is an essential component in beverage carbonation, food preservation, welding, and even agricultural processes.",
        applications: [
            "Food & Beverage Industry: Used for carbonating beverages, freezing, and chilling food products.",
            "Welding & Fabrication: Acts as a shielding gas in metal welding processes.",
            "Agriculture: Enhances plant growth in controlled environments like greenhouses.",
            "Industrial Cleaning: Dry ice blasting for non-abrasive, eco-friendly cleaning solutions."
        ],
        benefits: [
            "Enhances product quality and shelf life in the food industry.",
            "Provides eco-friendly cleaning solutions.",
            "Contributes to precision in industrial applications."
        ]
    }
]

const Products = () => {
    return(
        <>
            <HeadBanner imageUrl={bannerImg} />
            <OurProducts />
            <HorizontalBar />
            {
                ProdData.map(data=>(
                    <>
                    <Applications data={data} />
                    <HorizontalBar />
                    </>
                ))
            }
        </>
    )
}

export default Products;